import { Box, Collapse, IconButton, Typography, useTheme } from '@mui/material'
import { Icons, latexDelimiters } from '../../utils/utilities'
import React, { useMemo, useState } from 'react'
import ConfirmDialog from '../ConfirmDialog'
import Latex from 'react-latex-next'
import { useUserStore } from '../../store/user.store'
import EditQuestionDialog from './EditQuestionDialog'
import { useAdmissionExamStore } from '../../store/admission-exam.store'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react'
// import { useQuizAndQuestionbankStore } from '../../store/quizandquestionbank.store'


const optionsList = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

const QuestionBlock = observer( ( { readOnly = false, deleteQuestion, question, parent = 'approve', index, colors = false, defaultCollapseState = false, parentComponents = 'addexam' } ) => {

    const [deleting, setDeleting] = useState( false )
    const [open, setOpen] = useState( defaultCollapseState )
    const [editQuestionDialogState, setEditQuestionDialogState] = useState( false )
    const [deleteDialogState, setDeleteDialogState] = useState( false )

    const ExamStore = useAdmissionExamStore()
    const UserStore = useUserStore()

    const { palette, border } = useTheme()
    const { id } = useParams()

    const deleteQuestionProxy = () => {
        setDeleting( true )
        deleteQuestion( question.id )
        setDeleteDialogState( false )
        setDeleting( false )
    }

    const getQuestions = async () => {
        await ExamStore.fetchExam( id )
    }

    const displayQuestion = useMemo( () => {

        if ( !question?.translations || !ExamStore.getTranslationDetails )
            return question

        const questionDetails = {}

        const lang = ExamStore.getTranslationDetails?.selectedLanguage

        questionDetails.question_text = question?.translations[lang] || question.question_text
        questionDetails.question_type = question.question_type
        questionDetails.question_section = question.question_section
        questionDetails.options_status = question.options_status
        questionDetails.marks = question.marks
        questionDetails.question_id = question.question_id


        const finalOptions = []

        for ( const option of question.options ) {
            const optionsDetails = {}
            optionsDetails.answer_id = option.answer_id
            optionsDetails.answer_text = option?.translations[lang] || option.answer_text
            optionsDetails.answer_status = option.answer_status
            optionsDetails.question_id = option.question_id

            finalOptions.push( optionsDetails )
        }

        questionDetails.options = finalOptions

        return questionDetails

    }, [question, ExamStore.getTranslationDetails] )


    return (
        <Box bgcolor={open && palette.rowHover} sx={{ '&:hover': { bgcolor: palette.rowHover } }} padding="10px" borderRadius="5px">

            <ConfirmDialog waiting={deleting} status={deleteDialogState} cancelAction={() => setDeleteDialogState( false )} confirmAction={deleteQuestionProxy} actionName="Yes, Delete it!" message={`Do you really want to delete this question?`} />
            <EditQuestionDialog getQuestions={getQuestions} state={editQuestionDialogState} setState={setEditQuestionDialogState} question={question} />

            <Typography variant="subtitle2" color="textSecondary" fontSize="12px"> <em>Question {index + 1}</em> </Typography>
            <Box sx={{ cursor: "pointer" }} display="flex" gap="10px" paddingRight="10px" alignItems="center">
                <Box flexGrow={1} onClick={() => setOpen( !open )} display="flex" gap="10px" alignItems="flex-start">
                    <Box flexGrow={1}>
                        {/* <Box dangerouslySetInnerHTML={{ __html: displayQuestion.question_text || displayQuestion.question }}></Box> */}
                        <Box className='wysiwyg-text-container' fontWeight="bold" marginTop="-5px" fontSize="14px" >
                            <Latex delimiters={latexDelimiters} >{displayQuestion.question_text || displayQuestion.question}</Latex>
                        </Box>
                        <Typography marginBottom="4px" fontSize="10px" color="secondary">{displayQuestion.question_type || displayQuestion.questionType}</Typography>
                    </Box>
                </Box>

                <Box display="flex" gap="10px" alignItems="center">
                    {UserStore.getUser?.user_role === 'admin' && parent !== 'create' && <IconButton color="secondary" onClick={() => setEditQuestionDialogState( true )} sx={{ textTransform: "capitalize" }}>
                        {Icons.default.EditIconOutlined}
                    </IconButton>}
                    {!readOnly && <IconButton color="errorMessage" onClick={() => setDeleteDialogState( true )} sx={{ textTransform: "capitalize" }}>
                        {Icons.default.RemoveCircleIcon}
                    </IconButton>}
                </Box>
            </Box>
            <Collapse in={open}>
                <Box padding="10px" borderTop={border[1]}>
                    {displayQuestion.options.map( ( option, optionIndex ) => {

                        const isCorrect = +option.answer_status
                        return (
                            <Box display="flex" marginBottom="2px" alignItems="flex-start" gap="10px" key={optionIndex}>
                                <Typography marginBottom="2px" variant="subtitle2" fontSize="12px" sx={{ aspectRatio: 1 / 1 }} display="flex" alignItems="center" justifyContent="center" width='20px' borderRadius="50%" margin="0" bgcolor={isCorrect && "success.light"} fontWeight={isCorrect ? "bolder" : "regular"} color={isCorrect ? "white" : "textSecondary"}>{optionsList[optionIndex]}</Typography>
                                <Box variant="subtitle2" className='wysiwyg-text-container'  >
                                    <Latex delimiters={latexDelimiters} >{option.option_text || option.answer_text}</Latex>
                                </Box>
                            </Box>
                        )
                    } )}
                </Box>
            </Collapse>
        </Box >
    )
} )


export default QuestionBlock
